import React from "react";
import styled from "styled-components";
import Link from "gatsby-link";
import { getThemeColor } from "../../utils";

const LinkReset = styled.div`
  display: inline-flex;
  align-items: center;
  color: ${getThemeColor};
`;
const A = styled.a``;

export default ({ children, color, to = "", ...linkProps }) => {
  const external = to.indexOf("http") > -1;
  const urlProps = external
      ? {
          href: to
        }
      : {
          to
        },
    Component = external ? A : Link;
  return (
    <Component
      {...linkProps}
      {...urlProps}
      style={{
        display: "inline-flex",
        alignItems: "center",
        textDecoration: "none"
      }}
    >
      <LinkReset color={color}>
        {children}
      </LinkReset>
    </Component>
  );
};



// WEBPACK FOOTER //
// ./src/components/atoms/Link.js